export default __webpack_public_path__ + "static/media/logo-atlassian.d92c4f81.svg";